import {
  createValidation,
  validatorMaxLength,
  validatorNumber,
  validatorLength,
  validatorBankAccountNumber,
} from '../../utils/formValidators';

import { formRegisterBankFields } from '../../constants/formRegister';

export default createValidation([
  {
    name: formRegisterBankFields.BANK_ACCOUNT,
    validators: (field) => validatorBankAccountNumber()(field),
  },
  {
    name: formRegisterBankFields.RECEIVER_KMKR,
    validators: (field) => validatorMaxLength(30)(field),
  },
  {
    name: formRegisterBankFields.REFERENCE_NUMBER,
    validators: [
      (field) => validatorMaxLength(20)(field),
      (field) => validatorNumber()(field),
    ],
  },
  {
    name: formRegisterBankFields.RECEIVER_REGISTRY_CODE,
    validators: [
      (field) => validatorLength(8)(field),
      (field) => validatorNumber()(field),
    ],
  },
  {
    name: formRegisterBankFields.RECEIVER_NAME,
    validators: (field) => validatorMaxLength(30)(field),
  },
]);
